import { Injectable } from '@angular/core';
import { UserData } from '../models/user.model';
import { KEYS } from './keys';
import { environment } from 'src/environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { StripeTerminalReaderData } from '../models/stripe/stripe-terminal-reader-data';

@Injectable({
  providedIn: 'root'
})

export class SessionService {
  isProd = environment.production;
  
  constructor(private authService: AuthService) { }

  private hashData(data: string): string {
    let hash = 0;
    if (data.length === 0) return hash.toString();
    
    for (let i = 0; i < data.length; i++) {
      const char = data.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    
    // Add a salt and convert to base64-like string
    const salted = hash.toString(36) + '_' + btoa(data).split('').reverse().join('');
    return salted;
  }

  private unhashData(hashedData: string): string {
    try {
      const parts = hashedData.split('_');
      if (parts.length !== 2) return '';
      
      const reversed = parts[1].split('').reverse().join('');
      return atob(reversed);
    } catch (error) {
      console.error('Error unhashing data:', error);
      return '';
    }
  }

  isUserLoggedIn(): boolean {
    let rv = this.getUser();
    if(rv === null || rv === undefined){
      return false;
    }else { 
      return true
    };
  }

  getUserId(): string {
    return this.getUser().id;
  }

  getUser(): UserData {
    if(!this.isProd){
      return JSON.parse(sessionStorage.getItem(KEYS.user));
    }

    const hashedData = sessionStorage.getItem(KEYS.user);
    if (!hashedData) return null;
    
    try {
      const unhashedData = this.unhashData(hashedData);
      return JSON.parse(unhashedData);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  }

  setUser(value: UserData) {
    if(!this.isProd){
      sessionStorage.setItem(KEYS.user, JSON.stringify(value));
      return;
    }

    const jsonData = JSON.stringify(value);
    const hashedData = this.hashData(jsonData);
    sessionStorage.setItem(KEYS.user, hashedData);
  }

  removeUser() {
    sessionStorage.clear();
  }

  setSearchKey(key: any, value: any){
    sessionStorage.setItem(key.toString(), JSON.stringify(value));
  }

  getSearchKey(key: any): any{
    return JSON.parse(sessionStorage.getItem(key));
  }

  setGlobalOuting(outing: any){
    sessionStorage.setItem(KEYS.globalOuting.toString(), JSON.stringify(outing));
  }

  getGlobalOuting(): any{
    return JSON.parse(sessionStorage.getItem(KEYS.globalOuting));
  }

  setGlobalOutingIteration(iteration){
    sessionStorage.setItem(KEYS.globalOutingIteration.toString(), JSON.stringify(iteration));
  }

  getGlobalOutingIteration(): any{
    return JSON.parse(sessionStorage.getItem(KEYS.globalOutingIteration));
  }

  setTerminalReader(reader){
    sessionStorage.setItem(KEYS.stripeTerminalReader, reader);
  }

  getTerminalReader(): StripeTerminalReaderData{
    return JSON.parse(sessionStorage.getItem(KEYS.stripeTerminalReader));
  }

  setEnableAdaptiveUi(enable: boolean) {
    sessionStorage.setItem(KEYS.enableAdaptiveUi, enable.toString());
  }

  getEnableAdaptiveUi(): boolean {
    return JSON.parse(sessionStorage.getItem(KEYS.enableAdaptiveUi));
  }
}
